if (!customElements.get("m-localization-form")) {
  class MLocalizationForm extends HTMLElement {
    constructor() {
      super();
      const select = this.querySelector('[data-localization-select]');
      select && select.addEventListener('change', (e) => {
        const value = e.target.value
        // TODO: Replace the US store's Japan Market with Canada; keep Japan on nelpanda.jp.
        const storefrontUrl = e.target.selectedOptions[0]?.dataset.storefrontUrl
        if (storefrontUrl) {
          window.location.assign(storefrontUrl)
          return
        }
        const form = select.closest('[data-localization-form]')
        const input = form.querySelector('input[data-localization-input]')
        input && input.setAttribute('value', value)
        input && form.submit()
      });
    }
  }
  customElements.define('m-localization-form', MLocalizationForm);
}
